import { Options } from '@ph-core/enums/options.enum';
import { Lienholder } from '@ph-model/checkout/submit_cart/response/lienholder';
import { FinanceForm } from '@ph-model/form/finance-form';
import { IComplexDate } from '@ph-shared/utils/date-control-formater';
import { BorrowInfoForm } from '@ph-shopping/store/vehicle/vehicle.store';

export interface CreditInsuranceForm {
  addInsurance: string;
  loanTerm: number | null;
  loanAmount: number | null;
  monthlyPayment: string | null;
  interestRate: number | null;
  amortizationPeriod: number | null;
  residualValue: string | null;
  loanType?: string;
  loanEndDate?: string;
  downPayment?: string;
  firstPaymentDate?: IComplexDate | null;
  coMonthlyPayment?: string;
  primaryMonthlyPayment?: string;
}

export interface CheckoutCustomerInfo {
  businessFlag?: Options;
  businessName?: string;
  firstName: string;
  middleInitial: string;
  lastName: string;
  address: string;
  address2?: string;
  suiteApt: string;
  postalCode?: string | null;
  city: string;
  country: string;
  stateProvince: string;
  phone1: string;
  phone2: string;
  email: string;
  customerAgreementLanguage?: string;
  cosignerFlag?: Options;
  sameAddress?: Options;
}

export interface VehicleInfo {
  msrp: string;
  apr: string;
  financeAmount: string;
  registrationNumber: string;
  purchasePrice: string;
  grossCapCost?: string;
}

export interface CoverageInfoForm {
  coverageSelection: string;
  borrowerCoverage: string;
  insuranceTerm?: number | null;
}

export class CheckoutFormValues {
  customer: CheckoutCustomerInfo;
  lienholder: Lienholder;
  creditInsurance: CreditInsuranceForm | undefined;
  creditInsuranceForm: CreditInsuranceForm;
  borrowInfoForm: BorrowInfoForm;
  coverageInfoForm: CoverageInfoForm;
  financeForm: FinanceForm;
  cosigner: CheckoutCustomerInfo;
  vehicle: VehicleInfo;
  customerFormValid: boolean;
  cosignerFormValid: boolean;
  vehicleFormValid: boolean;
  lienholderFormValid: boolean;
  borrowerInfoFormValid: boolean;
  creditInsuranceFormValid: boolean;
  coverageInfoFormFormValid: boolean;
  financeFormValid: boolean;

  constructor() {
    this.customer = {} as CheckoutCustomerInfo;
    this.cosigner = {} as CheckoutCustomerInfo;
    this.vehicle = {
      msrp: '',
      grossCapCost: '',
      apr: '',
      financeAmount: '',
      registrationNumber: '',
      purchasePrice: '',
    };
    this.lienholder = {} as Lienholder;
    this.creditInsuranceForm = {
      addInsurance: Options.NO,
      loanTerm: null,
      loanAmount: null,
      monthlyPayment: null,
      interestRate: null,
      amortizationPeriod: null,
      residualValue: null,
    };
    this.borrowInfoForm = {} as BorrowInfoForm;
    this.coverageInfoForm = {
      coverageSelection: '',
      borrowerCoverage: '',
    };
    this.financeForm = {} as FinanceForm;
    this.customerFormValid = false;
    this.cosignerFormValid = false;
    this.vehicleFormValid = false;
    this.lienholderFormValid = false;
    this.borrowerInfoFormValid = false;
    this.creditInsuranceFormValid = false;
    this.coverageInfoFormFormValid = false;
    this.financeFormValid = false;
  }
}
